import { forwardRef, type HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { StringXSmall } from '@/components/Typography/Typography';

interface UserShortInfoProps extends HTMLAttributes<HTMLDivElement> {
  fullName: string;
  level: number;
  avatarUrl: string;
  classNames?: {
    avatar?: string;
    level?: string;
    fullName?: string;
  };
}

const UserShortInfo = forwardRef<HTMLDivElement, UserShortInfoProps>(
  ({ fullName, level, avatarUrl, classNames, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <div
        ref={ref}
        {...props}
        className={cn('flex items-center min-w-0', props.className)}
      >
        <img
          src={avatarUrl}
          className={cn('rounded-full w-8 h-8 mr-2', classNames?.avatar)}
          alt={fullName}
        />
        <div className="flex flex-col h-full flex-1 min-w-0">
          <StringXSmall
            className={cn(
              '!text-[12px] !leading-1.2 mb-1 whitespace-nowrap text-nowrap overflow-hidden text-ellipsis',
              classNames?.fullName,
            )}
          >
            {fullName}
          </StringXSmall>
          <StringXSmall
            className={cn('!text-[12px] !text-white/40', classNames?.level)}
          >
            {`${t('Level')} ${level}`}
          </StringXSmall>
        </div>
      </div>
    );
  },
);

export { UserShortInfo };
